import {isNil} from './is-nil';
import {isFunction} from './is-function';

export function isPromise(obj) {
    if (isNil(obj)) {
        return false;
    }

    const rawStr = Object.prototype.toString.call(obj);
    if (rawStr === '[object Promise]') {
        return true;
    }

    return isFunction(obj.then) && isFunction(obj.catch);
}
